import { Component, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import { AuthenticationService } from '../../providers/auth.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ThemeEmitterComponent } from '../tema/theme-emitter.component';
import { TemaService } from '../../providers/tema.service';
import { ConfiguracionEmpresaService } from '../../providers/configuracion-empresa.service';
import { ContactoService } from '../../providers/contacto.service';
import { Router } from '@angular/router';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css', './toolbar.component.scss']
})

export class ToolbarComponent implements AfterViewInit, OnInit {
  // Componente que contiene los colores de los temas para ser usados con "javascript" 
  // esto solo debe ser usado en los objetos CANVAS, el resto de componentes del sistema
  // no lo necesita ya que usan diramente las clases del archivo "styles-themes.scss"
  @ViewChild(ThemeEmitterComponent) theme: ThemeEmitterComponent;
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger: MatAutocompleteTrigger;
  searchQuery: any;
  contactOptions: any[] = [];
  dataOptions: any[] = [];
  showAutocompleteOptions: boolean = false;
  constructor(
    private temaServicio: TemaService,
    private contactoService: ContactoService,
    public authService: AuthenticationService,
    private authenticationService: AuthenticationService,
    public deviceService: DeviceDetectorService,
    private _confSv: ConfiguracionEmpresaService,
    private router: Router
  ) {
  }

  ngAfterViewInit(): void {
    this.onThemeChange(localStorage.getItem('theme'));
  }
  ngOnInit() {


  }

  ir_cuenta(){
    window.open("https://demos.itego.com.ar/itegosaas/public/reloginCRM?em=ZmFjdW5kbzIwMTQuZnBAZ21haWwuY29t", "_blank");
  }

  onSearch(): void {
    if (this.searchQuery) {
      this.contactoService.buscarDatos(this.searchQuery).subscribe(respuesta => {
        // Limpiar arrays antes de asignar nuevos datos
        this.contactOptions = [];
        this.dataOptions = [];
  
        // Verificar si la respuesta tiene datos válidos
        if (respuesta && respuesta.estado === 1 && respuesta.data) {
          const entidad = respuesta.data.Entidad;
          const contacto = respuesta.data.Contacto;
  
          // Agregar entidad a las opciones si existe
          if (entidad) {
            console.log('Aca esta la entidad', entidad);
            entidad.forEach(item => {
              this.contactOptions.push({
                id: item.idEntidad,
                nombre: item.nombre,
                razon: item.razonsocial || 'N/A',
                telefono: item.telefono || 'N/A'
              });
            });
          }
  
          // Agregar contacto a las opciones si existe
          if (contacto) {
            console.log('Aca esta la contacto', contacto);
            contacto.forEach(item => {
              this.dataOptions.push({
                id: item.ContactoIdEntidad,
                nombre: item.nombre + ' ' + item.apellido,
                razon: item.razonsocial || 'N/A',
                telefono: item.telefono || 'N/A'
              });
            });
          }
        }
      });
    } else {
      this.contactOptions = [];
      this.dataOptions = [];
    }
  }
  
  cerrarAutocomplete() {
    if (this.autocompleteTrigger.panelOpen) {
      this.autocompleteTrigger.closePanel();
    }
  }
  

  onThemeChange(newTheme: string) { // cambiar la clase del body
    this.temaServicio.setTema(newTheme, this.theme.getColores());
  }
}